import { deepMerge } from '@antfu/utils'
import type { App } from 'vue'
import { createVuetify } from 'vuetify'
import { VBtn } from 'vuetify/components/VBtn'
import { ru } from 'vuetify/locale'
import { VMaskInput } from 'vuetify/labs/VMaskInput'
import { VIconBtn } from 'vuetify/labs/VIconBtn'
import defaults from './defaults'
import { icons } from './icons'
import { staticPrimaryColor, staticPrimaryDarkenColor, themes } from './theme'
import { themeConfig } from '@themeConfig'

// Styles
import { cookieRef } from '@/@layouts/stores/config'
import '@core/scss/template/libs/vuetify/index.scss'
import 'vuetify/styles'

export default function (app: App) {
  const cookieThemeValues = {
    defaultTheme: resolveVuetifyTheme(themeConfig.app.theme),
    themes: {
      light: {
        colors: {
          'primary': cookieRef('lightThemePrimaryColor', staticPrimaryColor).value,
          'primary-darken-1': cookieRef('lightThemePrimaryDarkenColor', staticPrimaryDarkenColor).value,
        },
      },
      dark: {
        colors: {
          'primary': cookieRef('darkThemePrimaryColor', staticPrimaryColor).value,
          'primary-darken-1': cookieRef('darkThemePrimaryDarkenColor', staticPrimaryDarkenColor).value,
        },
      },
    },
  }

  const optionTheme = deepMerge({ themes }, cookieThemeValues)

  const vuetify = createVuetify({
    components: {
      VMaskInput,
      VIconBtn,
    },
    aliases: {
      IconBtn: VBtn,
      VBtnSecondary: VBtn,
    },
    defaults: {
      ...defaults,
      VBtnSecondary: {
        color: 'secondary',
        variant: 'tonal',
        rounded: 'lg',
      },
      VDialog: {
        transition: 'dialog-bottom-transition',
        // Отключает scale(1.03) bounce из VOverlay.animateClick при click-outside на persistent-диалоге.
        noClickAnimation: true,
      },
    },
    icons,
    theme: optionTheme,
    locale: {
      locale: 'ru',
      messages: { ru },
    },
  })

  app.use(vuetify)
}
